export enum Role {
  Admin = 1,
  Viewer = 2,
  SuperAdmin = 3
}
